import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  content: {
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    flexDirection: "column",
    backgroundColor: "#F5F5F5",
  },
  back: {
    marginTop: 24,
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "7px 14px",
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    background: "#F4F4F5",
    color: "#262626",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Inter",
    "&:hover": { background: "#E5E5E5" },
  },
  heading: {
    fontSize: 19,
    fontWeight: 700,
    fontFamily: "Inter",
    letterSpacing: "-0.015em",
    color: "#171717",
    margin: "10px 2px",
  },
  layout: {
    display: "grid",
    gridTemplateColumns: "230px 1fr",
    gap: 16,
    alignItems: "start",
    "@media (max-width: 900px)": { gridTemplateColumns: "1fr" },
  },
  rail: {
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(16,24,40,.04)",
    padding: 8,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    position: "sticky",
    top: 91,
  },
  railItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    width: "100%",
    textAlign: "left",
    padding: "10px 12px",
    borderRadius: 8,
    fontSize: 13.5,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#667085",
    background: "transparent",
    border: "none",
    cursor: "pointer",
  },
  railItemActive: {
    background: "#53389E",
    color: "#fff",
  },
  card: {
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(16,24,40,.04)",
    overflow: "hidden",
  },
  cardHead: {
    padding: "14px 22px",
    borderBottom: "1px solid #F3F4F6",
    fontSize: 15,
    fontWeight: 700,
    fontFamily: "Inter",
    letterSpacing: "-0.01em",
    color: "#171717",
  },
  cardBody: {
    padding: "6px 22px 16px",
  },
  row: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 20,
    padding: "14px 0",
    borderTop: "1px solid #F3F4F6",
    "&:first-of-type": { borderTop: "none" },
  },
  rowMain: { maxWidth: "60ch", flex: 1 },
  rowTitle: {
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#171717",
  },
  rowSub: {
    fontSize: 12.5,
    color: "#667085",
    fontFamily: "Inter",
    marginTop: 2,
    lineHeight: 1.5,
  },
  segmented: {
    display: "inline-flex",
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: 10,
    padding: 4,
    gap: 2,
    flexShrink: 0,
  },
  segItem: {
    padding: "6px 13px",
    borderRadius: 7,
    fontSize: 12.5,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#667085",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  segItemOn: {
    background: "#53389E",
    color: "#fff",
  },
  toggle: {
    width: 38,
    height: 22,
    borderRadius: 999,
    background: "#E5E5E5",
    position: "relative",
    flexShrink: 0,
    cursor: "pointer",
    border: "none",
    transition: "background .15s",
    "&::after": {
      content: '""',
      position: "absolute",
      top: 2,
      left: 2,
      width: 18,
      height: 18,
      borderRadius: "50%",
      background: "#fff",
      boxShadow: "0 1px 2px rgba(0,0,0,.15)",
      transition: "left .15s",
    },
  },
  toggleOn: {
    background: "#FFAF4A",
    "&::after": { left: 18 },
  },
  chipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
  },
  chip: {
    border: "1px solid #E5E5E5",
    background: "#F4F4F5",
    borderRadius: 6,
    padding: "7px 12px",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    cursor: "pointer",
  },
  chipOn: {
    background: "#FFF6E9",
    color: "#92400E",
    borderColor: "#FFE0B0",
  },
  input: {
    height: 38,
    border: "1px solid #E5E5E5",
    borderRadius: 8,
    padding: "0 12px",
    background: "#fff",
    fontSize: 13.5,
    color: "#171717",
    fontFamily: "Inter",
    width: "100%",
    maxWidth: 280,
    "&:focus": { outline: "none", borderColor: "#FFAF4A" },
  },
}));

export default useStyles;
